// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .menu-item {
    background-color: #2C303B;
} */


.menu-item, .menu-title {
    font-size: 12px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInZlcnRpY2FsbmF2LmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7OztBQUdIO0lBQ0ksZUFBZTtBQUNuQiIsImZpbGUiOiJ2ZXJ0aWNhbG5hdi5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLyogLm1lbnUtaXRlbSB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogIzJDMzAzQjtcbn0gKi9cblxuXG4ubWVudS1pdGVtLCAubWVudS10aXRsZSB7XG4gICAgZm9udC1zaXplOiAxMnB4O1xufSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/_layout/navigation/verticalnav/verticalnav.component.css"],"names":[],"mappings":"AAAA;;GAEG;;;AAGH;IACI,eAAe;AACnB;AACA,waAAwa","sourcesContent":["/* .menu-item {\n    background-color: #2C303B;\n} */\n\n\n.menu-item, .menu-title {\n    font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
